<p-confirmDialog />

<app-card-content [border]="false" [headerColor]="true" icon="pi pi-sitemap" title="Geridas" subtitle="Empresas administradas por esta gestora">
    <div card-header><app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" /></div>

    @if (classificacaoAdministradora()) {
        <app-tab-container [options]="options" [(selected)]="selected" [useHeader]="false">
            <app-tab-content value="ATIVAS">
                <app-custom-table
                    [metadata]="metadataAtivas"
                    [data]="ativasTabela()"
                    [columnOrder]="colunaOrdem"
                    [loading]="carregando()"
                    [totalRecords]="ativasTabela().length"
                    [showActions]="true"
                    [showExpandButton]="true"
                    [initialViewMode]="'table'"
                    [cardColumns]="2"
                    [permissaoUf]="pessoa()?.uf ?? null"
                />
                <div class="table-footer">
                    <span>Total: {{ ativasTabela().length }}</span>
                </div>
            </app-tab-content>

            <app-tab-content value="INATIVAS">
                <app-custom-table
                    [metadata]="metadataInativas"
                    [data]="inativasTabela()"
                    [columnOrder]="colunaOrdem"
                    [loading]="carregando()"
                    [totalRecords]="inativasTabela().length"
                    [showActions]="true"
                    [showExpandButton]="true"
                    [initialViewMode]="'table'"
                    [cardColumns]="2"
                    [permissaoUf]="pessoa()?.uf ?? null"
                />
                <div class="table-footer">
                    <span>Total: {{ inativasTabela().length }}</span>
                </div>
            </app-tab-content>
        </app-tab-container>
    } @else if (classificacaoAdministradora() === false) {
        <div class="guarda-classificacao">
            <i class="pi pi-info-circle"></i>
            <span>Disponível apenas para prestadores com classificação Administradora/Gestora de Serviços Médicos.</span>
        </div>
    } @else if (verificandoClassificacao()) {
        <div class="guarda-classificacao">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Verificando classificação do prestador...</span>
        </div>
    }
</app-card-content>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Vínculo entre gestora e gerida."
    [visible]="dialogVisivel()"
    (visibleChange)="dialogVisivel.set($event)"
    [style]="{ width: 'min(94vw, 640px)' }"
    [appendTo]="'body'"
    [header]="registroEmEdicao() ? 'Editar gestão' : 'Vincular gerida'"
>
    <form [formGroup]="form" class="gerida-form">
        <div class="gerida-form__full">
            <label>Gerida *</label>
            <div class="gerida-form__search">
                <input pInputText formControlName="nome" readonly placeholder="Selecione a gerida" />
                @if (!registroEmEdicao()) {
                    <p-button label="Localizar" icon="pi pi-search" severity="secondary" (onClick)="abrirPesquisa()" />
                }
            </div>
        </div>

        <div>
            <label>CRM</label>
            <input pInputText formControlName="crm" readonly />
        </div>

        <div>
            <label>UF</label>
            <input pInputText formControlName="ufGerido" readonly />
        </div>

        @if (geridaNaoDefinitiva()) {
            <div class="gerida-form__full gerida-aviso gerida-aviso--erro">
                <i class="pi pi-times-circle"></i>
                <span>Somente prestadores com inscrição Definitiva podem ser vinculados como gerida.</span>
            </div>
        }

        @if (alteraTipoGestao()) {
            <div class="gerida-form__full gerida-aviso">
                <i class="pi pi-exclamation-triangle"></i>
                <span>O tipo de gestão da gerida será alterado para Terceirizada.</span>
            </div>
        }

        <div>
            <label>Data Início *</label>
            <input pInputText type="date" formControlName="dtInicio" />
        </div>

        @if (registroEmEdicao()) {
            <div>
                <label>Data Fim</label>
                <input pInputText type="date" formControlName="dtFim" />
                @if (datasInvalidas()) {
                    <small class="field-error">Data fim não pode ser menor que a data de início.</small>
                }
            </div>
        }

        <div class="gerida-form__full">
            <label>Documento Comprobatório {{ registroEmEdicao() ? '' : '*' }}</label>
            <input type="file" accept="application/pdf,image/*" (change)="onArquivoSelecionado($event)" />
            @if (nomeArquivo()) {
                <small class="gerida-arquivo">{{ nomeArquivo() }}</small>
            } @else if (registroEmEdicao()) {
                <small class="gerida-arquivo">Deixe em branco para manter o documento atual.</small>
            }
        </div>
    </form>

    <ng-template #footer>
        <p-button label="Cancelar" severity="secondary" (onClick)="dialogVisivel.set(false)" />
        <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" [disabled]="form.invalid || datasInvalidas() || geridaNaoDefinitiva()" (onClick)="salvar()" />
    </ng-template>
</p-dialog>

<app-pesquisar-pessoa-custom [(showDialog)]="pesquisaVisivel" [tiposPessoaPermitidos]="['PRESTADOR']" (pessoa)="selecionarGerida($event)" />
